
  import {Component, Vue} from "vue-property-decorator";
  import {IApp} from "@/interfaces/app.interface";
  import {isChrome, isEdge, isFirefox, isIOS, isMobile} from "mobile-device-detect";
  import {IAppState} from "@/interfaces/app-state.interface";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

  @Component({})
  export default class AppInstallation extends Vue {
    installPrompt: any;
    installReady = false;
    appInstalled = false;
    wasClosed = false;
    isMobile = isMobile;
    dontDisplay = false;

    get storeState(): IAppState { return this.$store.state; }
    get isUser() { return this.storeState.auth.isUser; }
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get displayOnThisPage() { return [IApp.ROUTE_NAME.HOME].includes(this.$route.name as IApp.ROUTE_NAME); }
    get baseDisplay() { return !this.wasClosed && this.displayOnThisPage && this.isMobile && !this.appInstalled; }
    get displayBanner() { return this.installReady && this.baseDisplay; }
    get displayWhenCantInstall() { return !this.dontDisplay && this.cantInstall && this.baseDisplay; }

    get cantInstall() { return isIOS || !(isChrome || isEdge || isFirefox); }

    created() {
      if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
          navigator.serviceWorker.register('/service-worker.js')
            .then(registration => {
              // console.log('SW registered: ', registration);
            })
            .catch(registrationError => {
              // console.log('SW registration failed: ', registrationError);
            });
        });
      }

      window.addEventListener('beforeinstallprompt', this.savePrompt);
      window.addEventListener('appinstalled', this.handleAppInstalled);

      let dontDisplayStorage = localStorage.getItem(IApp.LocalStorageKeys.DontDisplayInstallBanner);
      if (dontDisplayStorage) {
        this.dontDisplay = JSON.parse(dontDisplayStorage);
      }
    }

    async mounted() {
      await this.checkDisplayMode();
    }

    async checkDisplayMode() {
      // Ключевая проверка: находится ли приложение в 'standalone' или 'fullscreen' режиме
      const isInstalled = window.matchMedia('(display-mode: standalone)').matches ||
        window.matchMedia('(display-mode: fullscreen)').matches ||
        window.matchMedia('(display-mode: minimal-ui)').matches;

      // Специальная проверка для iOS (Safari)
      const isIosInstalled = (window as any).navigator.standalone === true;

      if (this.isUser && (isInstalled || isIosInstalled)) {
        let appPreviousRoute = localStorage.getItem(IApp.LocalStorageKeys.PreviousRoute);
        if (appPreviousRoute
          && !IApp.RedirectBlackList.includes(appPreviousRoute as IApp.ROUTE_NAME)
          && this.$route.name === IApp.ROUTE_NAME.HOME) {
          await this.$store.dispatch('openPage', { routeName: appPreviousRoute });
        }
        else {
          await this.$store.dispatch('openPage', { routeName: IApp.ROUTE_NAME.HOME });
        }
      }
    }

    async savePrompt(event) {
      event.preventDefault();
      this.installPrompt = event;
      this.installReady = true;
    }

    async installPWA() {
      if (this.cantInstall) {
        await this.$store.dispatch('dialog/openDialog', {blockName: 'home', dialogName: 'installAppInstruction'});
      }
      else if (this.installPrompt) {
        this.installPrompt.prompt();
      }
    }

    async handleAppInstalled() {
      this.installPrompt = null;
      this.appInstalled = true;
    }

  }
